/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import IFlexService = Services.IFlexService;

    const FLEX_SERVICES_DESCRIPTIONS: { [name: string]: string } = {
        "atemesnmpadapter": "Adapter for Ateme devices",
        "flexauth": "Handles authentication across the application",
        "flexbackend": "Flex core functionality",
        "flexcollector": "Collects data from other services",
        "ikusnetsnmpadapter": "Adapter for Ikusnet devices",
        "influxdb": "Influx database. Stores trending data",
        "kafka": "Handles events using Kafka",
        "mvp-adapter2": "Collects stats from MVP devices",
        "mvpadapter": "Handles MVP devices connections",
        "nevionadapter": "Adapter for Nevion devices",
        "postgres": "Postgres database",
        "sonadapter": "Adapter for SON",
        "srtgateway": "Adapter for SRT Gateway devices",
        "registrator": "Support service for registering third-party services",
        "digiconadapter": "Adapter for Digicon",
    };

    export class FlexServicesController {
        public static $name: string = "flexServicesController";
        public static $inject: string[] = ["$scope",
                                           'flexWatchdogService',
                                           '$interval',
                                           ];

        public servicesStatus: IFlexServiceByNode[][] = [];
        public servicesStatusMap: IServicesStatusMap = {};
        public loading: boolean;
        private servicesInterval: angular.IPromise<void>;

        constructor(private $scope: ng.IScope,
                    private flexWatchdogService: Services.FlexWatchdogService,
                    private $interval: ng.IIntervalService) {
            this.loading = true;
            //Trick to init with two nodes
            this.loadCurrentServicesStatus().then(() => {
                this.loadCurrentServicesStatus();
            });
            this.$scope.$on("$destroy", () => {
                if (this.servicesInterval !== undefined) {
                    this.$interval.cancel(this.servicesInterval);
                }
            });
            this.servicesInterval = this.$interval(() => {
                this.loadCurrentServicesStatus();
            }, 7000);
        }

        public startService(service: IFlexServiceByNode): ng.IPromise<void> {
            service.loading = true;
            return this.flexWatchdogService.startService(service.name).then((result: boolean) => {
                Common.Utils.alertOnSuccess(`Service ${service.name} started succesfully.`);
                service.loading = false;
                this.loadCurrentServicesStatus();
            }).catch((e: ngCustom.IReason) => {
                service.loading = false;
                Common.Utils.alertOnError(`Error starting service. ${e}`);
                this.loadCurrentServicesStatus();
            });
        }

        public stopService(service: IFlexServiceByNode): ng.IPromise<void> {
            service.loading = true;
            return this.flexWatchdogService.stopService(service.name).then((result: boolean) => {
                service.loading = false;
                Common.Utils.alertOnSuccess(`Service ${service.name} stopped succesfully.`);
                this.loadCurrentServicesStatus();
            }).catch((e: ngCustom.IReason) => {
                service.loading = false;
                Common.Utils.alertOnError(`Error stopping service. ${e}`);
                this.loadCurrentServicesStatus();
            });
        }

        public getStatusColor(status: string): string {
            return this.flexWatchdogService.getStatusColor(status);
        }

        public blockStopButton(service: IFlexServiceByNode): boolean {
            return service.statuses.length < 1 || service.statuses.every((status: string) => status === 'exited')
                   || service.loading || service.name === 'flexbackend' || service.name === 'postgres';
        }

        public blockPlayButton(service: IFlexServiceByNode): boolean {
            return service.statuses.length < 1 || service.statuses.every((status: string) => status === 'running')
               || service.loading;
        }

        public removeContainer(service: IFlexServiceByNode, index: number): void {
            const containerName = service.containerNames[index];
            console.log("Removing container " + containerName);
            this.flexWatchdogService.removeContainer(containerName, service.node);
        }

        private loadCurrentServicesStatus(): ng.IPromise<void> {
            return this.flexWatchdogService.listServices().then((servicesStatus: IFlexService[]) => {
                const [aService] = servicesStatus.filter((flexService: IFlexService) => flexService && flexService.node)
                const nodeName: string = aService ? aService.node : undefined;
                if (this.servicesStatusMap === undefined) {
                    this.servicesStatusMap = {};
                }
                servicesStatus.forEach((flexService: IFlexService) => {
                    if (flexService) {
                            let flexServiceByNodes: IFlexServiceByNode[] = this.servicesStatusMap[flexService.name];
                            if (flexServiceByNodes === undefined) {
                                this.servicesStatusMap[flexService.name] = [];
                                flexServiceByNodes = this.servicesStatusMap[flexService.name];
                            }
                            const [nodeService] = flexServiceByNodes.filter((service: IFlexServiceByNode) => {
                                return service.node === nodeName;
                            });
                            if (nodeService) {
                             nodeService.statuses = flexService.status;
                            } else {
                                let description = "";
                                if (FLEX_SERVICES_DESCRIPTIONS[flexService.name]) {
                                    description = FLEX_SERVICES_DESCRIPTIONS[flexService.name]
                                }
                                flexServiceByNodes.push({
                                    name: flexService.name,
                                    node: nodeName,
                                    description: description,
                                    statuses: flexService.status,
                                    containerNames: flexService.containerNames,
                                    loading: false,
                                });
                            }
                    }
                });
                this.servicesStatus = Object.keys(this.servicesStatusMap).map((serviceName: string) => {
                    return this.servicesStatusMap[serviceName];
                });
                // this.loadDescriptions();
                this.loading = false;
            });
        }

    }
}

interface IServicesStatusMap {
    [ key: string ]: IFlexServiceByNode[];
}

interface IFlexServiceByNode {
    name: string;
    node: string;
    description: string;
    statuses: string[];
    loading: boolean;
    containerNames: string[];
}


